module.exports = __webpack_public_path__ + "static/img/img19.9b3c962.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img19.png
// module id = sfJD
// module chunks = 1